export default {
  // home

  // ui
  entrar: "Enter",
  play: "Play",
  pause: "Pause",
  subtitles: "Subtitles",
  pantalla_completa: "Full screen",
  salir_pantalla_completa: "Exit full screen",
  escena_completada: "Scene completed",

  // overlays
  r1_1: "A) Yes, these are types of cover that are taken out separately from the basic policy.",
  r1_2: "B) No, home insurance usually covers water damage, fire, theft and liability.",
  r1_3: "C) Yes, they are included in any standard home insurance policy.",

  r2_1: "A) It keeps growing on its own because the longer it is left untouched, the more it grows.",
  r2_2: "B) It neither grows nor loses value because leaving it untouched has no effect.",
  r2_3: "C) If it is left untouched, it does not grow. In fact, it loses value. To generate a return, it needs to be put somewhere where it can work for you.",

  r3_1: "A) The property and everything inside it, because the insurance automatically calculates what you buy, keep or throw away each day.",
  r3_2: "B) The property and its contents, although the value of the contents must be declared.",
  r3_3: "C) The contents of the property; the property itself is already covered by the bank when the mortgage is granted.",

};